/* @flow */

import * as React from 'react';

import {Body} from 'shells/typography';

import './account-card-contents.module.css';

type Props = {|
    description: ?string,
    location: ?string,
    phoneNumber?: ?string,
    phoneExtension?: ?string,
    connectButtonsRow?: React.Node,
|};

export function AccountCardContents(props: Props) {
    return (
        <div className='flex flex-dir-col gap-2'>
            {props.description && (
                <div styleName='description-container'>
                    <Body size='small' as='div' wrapAnywhere={true} title={props.description}>
                        {props.description}
                    </Body>
                </div>
            )}
            {props.phoneNumber && (
                <Body size='small' as='div'>
                    {props.phoneNumber} {props.phoneExtension && `ext. ${props.phoneExtension}`}
                </Body>
            )}
            <Body size='small' as='div' color='placeholder' wrapAnywhere={true}>
                {props.location ? props.location : 'No location'}
            </Body>
            {props.connectButtonsRow}
        </div>
    );
}
